import React, { Component } from 'react'
import PropTypes from 'prop-types'
import throttle from 'lodash.throttle'

// use babel-import-plugin as specified in Ant Design Docs!
// https://ant.design/docs/react/getting-started#Import-on-Demand
import { Popover, Icon } from 'antd'

class Breakpoint extends Component {
  state = {
    viewportWidth: 0,
    menuVisible: false,
  }

  componentDidMount() {
    this.saveViewportDimensions()
    window.addEventListener('resize', this.saveViewportDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.saveViewportDimensions)
  }

  handleMenuVisibility = menuVisible => {
    this.setState({ menuVisible })
  }

  saveViewportDimensions = throttle(() => {
    this.setState({
      viewportWidth: window.innerWidth,
    })
  }, this.props.throttle)

  render() {
    return this.props.render(this.state.viewportWidth < this.props.width)
  }
}

Breakpoint.propTypes = {
  width: PropTypes.number,
  throttle: PropTypes.number,
  render: PropTypes.func.isRequired,
}

Breakpoint.defaultProps = {
  width: 575,
  throttle: 250,
  render: () => null,
}

export default Breakpoint



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Breakpoint.jsx